import React, { useEffect, useState } from 'react';
import { HiChevronDown, HiTrash } from 'react-icons/hi';
import { StrategyMapDependency } from '../../../StrategyMapDependencyMapper/StrategyMapDependencyMapper';
import './SmapDependencyCard.css';
import { FaEdit } from 'react-icons/fa';
import ConfirmationDialog from '../../../../pages/DashboardNew/components/ConfirmationDialog';
import { getEntityTypeDisplay } from '../../../../utils/entityDisplayUtils';

interface SmapDependencyCardProps {
  dependency: StrategyMapDependency;
  onRemove: () => void;
  onEdit?: (data: StrategyMapDependency) => void;
  entityType?: string;
  onExpanded?: (open: boolean) => void;
  expanded?: boolean;
  EditorComponent?: React.ComponentType<{
    dependency: { selectedSource: string; selectedDependencies: string[] };
  }>;
}

const SmapDependencyCard: React.FC<SmapDependencyCardProps> = ({
  dependency,
  onRemove,
  onEdit,
  entityType = "Work Item",
  onExpanded,
  expanded,
  EditorComponent
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const [deleteConf, setDeleteConf] = useState<{
    show: boolean;
    position?: { top: number; left: number };
  }>({ show: false });

  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const handleRemoveClick = (e: React.MouseEvent) => {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    
    setDeleteConf({
      show: true,
      position: {
        top: rect.top,
        left: rect.left - 215
      }
    });
  };


  const handleEdit = () => {
    setIsEditing((pv)=>!pv);
    setIsExpanded(true);
  }
  const entityInfo = getEntityTypeDisplay(
      dependency?.entity_type ?? "strategy_map",
      dependency.type,
    );
  
    const IconComponent = entityInfo.icon;
   
  return (
    <div
      className={`smap-dependency-card ${isExpanded ? "smap-dependency-card--expanded" : ""}`}
    >
      {/* Header */}
      <div
        className="smap-dependency-card__header group"
        onClick={() => {
          onExpanded?.(isExpanded);

          setIsExpanded(!isExpanded);
        }}
      >
        <span className="smap-dependency-card__bullet">
          <IconComponent />
        </span>
        <span className="smap-dependency-card__title" title={dependency.name}>
          {dependency.name}
        </span>
        <button
          className="smap-dependency-card__expand-btn"
          aria-label="Expand item"
        >
          <span
            className={`smap-dependency-card__expand-icon ${isExpanded ? "smap-dependency-card__expand-icon--expanded" : ""}`}
          >
            <HiChevronDown size={18} />
          </span>
        </button>
      </div>

      {/* Sub-header status and actions */}
      <div className="smap-dependency-card__meta">
        <img
          src={"/configuration%20green.svg"}
          alt="Dependency"
          className="w-4 h-4 mr-2 inline-block"
        />
        <span className="smap-dependency-card__badge">
          {dependency.dependency.length}{" "}
          {dependency.dependency.length === 1 ? "Dependency" : "Dependencies"}
        </span>

        <div className="smap-dependency-card__actions">
          <button
            className="smap-dependency-card__edit-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit();
            }}
            title="Edit mapping"
          >
            <FaEdit className="smap-dependency-card__edit-icon" size={14} />
          </button>
          <button
            className="smap-dependency-card__delete-btn"
            onClick={(e) => {
              // e.stopPropagation();
              handleRemoveClick(e);
            }}
            title="Delete mapping"
          >
            <HiTrash className="smap-dependency-card__delete-icon" size={14} />
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="smap-dependency-card__content">
          <div className="smap-dependency-card__label">Depends on</div>
          {dependency.dependency.map((dep) => {
              const entityInfo = getEntityTypeDisplay(
                dep?.entity_type ?? "strategy_map",
                dep.type,
              );

              const DepChildIconComponent = entityInfo.icon;
            return (
              <div key={dep.id} className="smap-dependency-card__item">
                <span
                  className="smap-dependency-card__item-badge"
                  title={dep.name}
                >
                  {dep.name}
                </span>
                <span className="smap-dependency-card__item-type ml-auto">
                  <DepChildIconComponent />
                </span>
              </div>
            );
          })}
        </div>
      )}

      {isEditing && EditorComponent && isExpanded && (
        <EditorComponent
          dependency={{
            selectedSource: dependency.id,
            selectedDependencies: dependency.dependency.map((d) => d.id),
          }}
        />
      )}

      <ConfirmationDialog
        isOpen={deleteConf.show}
        type="single"
        position={deleteConf.position}
        dependencyName={dependency.name}
        entityLabel="dependency"
        onConfirm={() => {
          onRemove();
          setDeleteConf({ show: false });
        }}
        onCancel={() => setDeleteConf({ show: false })}
      />
    </div>
  );
};

export default SmapDependencyCard;
